<template>
  <div>

    <vx-card class="mt-3">

      <vs-row vs-type="flex" >
        <vs-col vs-lg="8" vs-sm="12" vs-xs="12" >
          <vs-row  vs-type="flex" >
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span>Nome</span>
              <vs-input class="w-full d-theme-input-dark-bg" v-model="name" @keyup.enter="refine(cnpj, name)" @keyup.esc="refine(cnpj, name)" />
            </vs-col>
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span>Cnpj</span>
              <NumericInput
                minimumFractionDigits="0"
                class="w-full d-theme-input-dark-bg"
                is-cnpj="true"
                v-model="cnpj"/>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-lg="4" vs-sm="12" vs-xs="12" vs-align="center" class="mt-4">
          <vs-row vs-align="center" >
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mt-1">
              <vs-button class="w-full" @click="clearFilter()" icon-pack="fa" icon="fa-eraser" title="Limpar">
                <span class="auto-hide-clear-text" >Limpar</span>
              </vs-button>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mt-1">
              <vs-button class="w-full" @click="refine(cnpj, name)" icon="search">Buscar</vs-button>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row class="mt-10">
        <vs-col>
          <vs-table stripe class="w-full" :data="creditReports" noDataText="Nenhum relatório de crédito cadastrado.">
            <template slot="thead">
              <th>Empresa</th>
              <th>Cnpj</th>
              <th>Data</th>
              <th>Score</th>
              <th>Status</th>
              <th>Criado Por</th>
              <th>Data de Criação</th>
              <th></th>
            </template>

            <template v-slot="{data}">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">
                <td>
                  <a
                    v-if="row.company"
                    :href="$router.resolve({ path: '/balanco/' + row.company.guid }).href"
                    class="vx-logo cursor-pointer mx-auto flex items-center text-primary"
                  >
                    {{ row.company.name }}
                  </a>
                </td>
                <td>
                  <span v-if="row.company">{{row.company.cnpj | formatCnpj}}</span>
                </td>
                <td>
                  {{row.createdAt | formatDate}}
                </td>
                <td>
                  {{row.score}}
                </td>
                <td>
                  {{row.status | formatCreditReportStatus}}
                </td>
                <td>
                  {{row.createdBy.email}}
                </td>
                <td>
                  {{row.createdAt | formatDateTime}}
                </td>
                <td>
                  <a v-if="row.status === 'DONE'" role="button" style="cursor: pointer" @click="downloadReport(row.guid)">Download</a>
                </td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="my-5">
            <vs-pagination
              v-model="page"
              :total="totalPages">
            </vs-pagination>
          </div>

        </vs-col>
      </vs-row>
    </vx-card>

  </div>
</template>
<script>
import axios from "axios";
import NumericInput from "@/components/NumericInput.vue";

export default {
  name: 'ReportList',
  components: {NumericInput},
  data() {
    return {
      creditReports: [],
      name: null,
      cnpj: null,
      page: 1,
      totalPages: 0,
      limit: 20
    }
  },
  watch: {
    page () {
      this.refresh()
    }
  },
  beforeMount() {
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh () {
      this.loadCreditReportTable()
    },

    loadCreditReportTable() {
      axios
        .get(`${process.env.VUE_APP_API}/api/v1/finance/credit-report`, {
          params: {
            page: this.page - 1,
            limit: this.limit,
            companyName: this.name,
            cnpj: this.cnpj,
          },
        })
        .then((response) => {
          this.creditReports = response.data.content; // Atualiza a lista de relatórios
          this.totalPages = response.data.totalPages;
        })
    },

    refine (cnpj, name) {
      this.cnpj = cnpj
      this.name = name
      this.page = 1
      this.refresh()
    },

    clearFilter () {
      this.cnpj = null
      this.name = ''
      this.page = 1
      this.refresh()
    },

    downloadReport(reportGuid) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/finance/credit-report/${reportGuid}`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },

  }
}
</script>
